import { cn } from '@/lib/utils'

export const IndicatingBar = () => {
  return (
    <div className={cn('absolute left-0 top-0', 'w-full', 'h-[8px]', 'bg-slate-300')}>
      {/* Progress bar */}
      <div
        className={cn(
          'absolute left-0 top-0',
          'w-full',
          'h-full',
          'rounded-[40px]',
          'bg-gradient-to-r from-blue-50 to-blue-600',
          'animate-pulse'
        )}
      />
    </div>
  )
}
